module.exports = __webpack_public_path__ + "static/media/4.7db125b9.jpg";